import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { UTMParamTable } from "./components/utm-param-table";
import { URLVerification } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.IMPACT_RADIUS;

export const ImpactRadiusDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const ImpactRadiusSetup = () => (
  <>
    <SetupSection title="Update parameter pairs in Impact Radius’s ‘Partner Tracking Template’ page">
      <UTMParamTable platform={PLATFORM} />
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
